// extracted by mini-css-extract-plugin
module.exports = {"root":"HeaderSearchBar_root__I5rwc","input":"HeaderSearchBar_input__pbGgc"};